export default __webpack_public_path__ + "static/middle-49fe314cdb63a1af859c785082167d42.jpg";